document.querySelectorAll('.accordion-title').forEach(item => {
    item.addEventListener('click', function () {
        const parent = this.parentElement;
        parent.classList.toggle('active');
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var searchBar = document.getElementById('accordion_search_bar');
    var accordionItems = document.querySelectorAll('.accordion-item');
    var notFoundMessage = document.querySelector('.only_if_not_found');

    searchBar.addEventListener('input', function() {
        var searchTerm = searchBar.value.toLowerCase();
        var hasResults = false;

        if (searchTerm.length < 3) {
            accordionItems.forEach(function(item) {
                item.style.display = ''; // Réafficher tous les éléments
                var contentElement = item.querySelector('.accordion-content');
                var chevron = item.querySelector('.chevron');
                contentElement.style.maxHeight = null;
                chevron.classList.remove('rotate');
            });
            notFoundMessage.style.display = 'none'; 
            return; 
        }

        accordionItems.forEach(function(item) {
            var title = item.querySelector('.accordion-title').textContent.toLowerCase();
            var content = item.querySelector('.accordion-content').textContent.toLowerCase();
            var contentElement = item.querySelector('.accordion-content');
            var chevron = item.querySelector('.chevron');

            if (title.includes(searchTerm) || content.includes(searchTerm)) {
                item.style.display = ''; 
                contentElement.style.maxHeight = contentElement.scrollHeight + "px"; 
                chevron.classList.add('rotate'); 
                hasResults = true;
            } else {
                item.style.display = 'none'; 
                contentElement.style.maxHeight = null;
                chevron.classList.remove('rotate');
            }
        });

        if (!hasResults) {
            notFoundMessage.style.display = 'block';
        } else {
            notFoundMessage.style.display = 'none';
        }
    });

    accordionItems.forEach(function(item) {
        var title = item.querySelector('.accordion-title');
        var contentElement = item.querySelector('.accordion-content');
        var chevron = item.querySelector('.chevron');

        title.addEventListener('click', function() {
            if (contentElement.style.maxHeight) {
                contentElement.style.maxHeight = null;
                chevron.classList.remove('rotate');
            } else {
                contentElement.style.maxHeight = contentElement.scrollHeight + "px";
                chevron.classList.add('rotate');
            }
        });
    });
});